import { render, staticRenderFns } from "./OwnerCreationSuccess.vue?vue&type=template&id=74d5f011&scoped=true&"
import script from "./OwnerCreationSuccess.vue?vue&type=script&lang=js&"
export * from "./OwnerCreationSuccess.vue?vue&type=script&lang=js&"
import style0 from "./OwnerCreationSuccess.vue?vue&type=style&index=0&id=74d5f011&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74d5f011",
  null
  
)

export default component.exports